import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/$locale/onboarding")({
  ssr: false, // CSR only - no SEO needed for onboarding
});
